<script setup>
import { trans } from '@elements/translation';
import { useInvoiceModalStore } from '@organisms/ubiq-administration/store/invoiceModal';
import { EVENT_SLIDERS } from '../../general/event-constants';

const modalStore = useInvoiceModalStore();
const emit = defineEmits([ 'openModal' ]);

const emitClick = () => {
  modalStore.setDetails({ partialMode: true });

  emit('openModal', {
    title: trans('gestion.invoices.slider.partial_credit_note'),
    name: EVENT_SLIDERS.CREATE_PARTIAL_CREDIT_NOTE,
  });
};
</script>

<template>
  <li @click="emitClick">
    <span>{{ trans('gestion.invoices.create_partial_credit_note') }}</span>
  </li>
</template>
